export enum DistanceMeasurement {
    Kilometres,
    Miles
}
